// extracted by mini-css-extract-plugin
export default {"header":"DevicePicker__header--yA-5u","item":"DevicePicker__item--xUJ1Z"};